import utils from './utils';

/* -------------------------------------------------------------------------- */
/*                                  Copy LinK                                 */
/* -------------------------------------------------------------------------- */

const copyLink = () => {
  const copyLinkModal = document.getElementById('copyLinkModal');
  copyLinkModal &&
    copyLinkModal.addEventListener('shown.bs.modal', () => {
      const invitationLink = document.querySelector('.invitation-link');
      invitationLink.select();
    });

  const copyButtons = document.querySelectorAll('[data-copy]');
  copyButtons &&
    copyButtons.forEach(button => {
      if (!window.bootstrap || !window.bootstrap.Tooltip) return;

      // Avoid multiple Tooltip instances per element (Tooltips are globally initialized elsewhere).
      // Use manual trigger since this module explicitly shows/hides the tooltip.
      let tooltip = window.bootstrap.Tooltip.getOrCreateInstance(button, {
        trigger: 'manual',
        container: 'body'
      });

      button.addEventListener('mouseover', () => tooltip.show());
      button.addEventListener('mouseleave', () => tooltip.hide());

      button.addEventListener('click', e => {
        e.stopPropagation();

        const el = e.currentTarget;

        const originalTitle =
          el.getAttribute('data-bs-title') ||
          el.getAttribute('title') ||
          'Copy to clipboard';

        // Temporarily change tooltip text
        el.setAttribute('data-bs-title', 'Copied');

        if (typeof tooltip.setContent === 'function') {
          tooltip.setContent({ '.tooltip-inner': 'Copied' });
        } else {
          tooltip.dispose();
          tooltip = window.bootstrap.Tooltip.getOrCreateInstance(el, {
            trigger: 'manual',
            container: 'body'
          });
          tooltip.show();
        }

        const inputID = utils.getData(el, 'copy');
        const input = document.querySelector(inputID);
        input.select();
        document.execCommand('copy');

        // Restore tooltip text
        el.setAttribute('data-bs-title', originalTitle);

        if (typeof tooltip.setContent === 'function') {
          tooltip.setContent({ '.tooltip-inner': originalTitle });
        }
      });
    });
};

export default copyLink;
